import clsx from 'clsx';
import type { PropsWithChildren, ReactNode } from 'react';

type Props = PropsWithChildren<{
  label: ReactNode;
  addon?: ReactNode;
  className?: string;
}>;

export function OptionFormGroup({ label, children, addon, className }: Props) {
  return (
    <div className={clsx('form-group form-group-sm d-flex align-items-center my-1 no-gutters', className)}>
      <div className="d-flex justify-content-end pe-1 col-form-label col-form-label-sm col-4 text-nowrap">{label}</div>
      <div className="d-flex fs-6 px-1 col-7">{children}</div>

      {addon}
    </div>
  );
}
